import Stack from '@mui/material/Stack'
import { observer } from 'mobx-react-lite'

import { Icon, Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../common'

export const SubBudgetZeroState = observer(() => {
  const { budgets: copy } = useGlobalCopyStore()

  return (
    <Stack alignItems="center" gap={12} height="auto" mb={24} mt={24}>
      <Icon color="action" name="bubble_chart" sx={{ fontSize: 32 }} />
      <Text bold={true} color="text.secondary" variant="body2">
        {copy.zero_state_no_sub_budgets}
      </Text>
      <Text color="text.secondary" variant="caption">
        {copy.zero_state_no_sub_budgets_description}
      </Text>
    </Stack>
  )
})
